import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FileSaverService} from 'ngx-filesaver';

@Component({
  selector: 'ldap-server-certificate-view',
  templateUrl: './ldap-server-certificate-view.component.html',
  styleUrls: ['./ldap-server-certificate-view.component.scss']
})
export class LdapServerCertificateViewComponent implements OnInit {

  onApply = new EventEmitter();
  onCancel = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<LdapServerCertificateViewComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public fileSaverService: FileSaverService) { }

  ngOnInit(): void {

  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data);
  }

  downloadPem(): void {
    const fileType = {type: 'text/plain'};
    const blob = new Blob([this.data.certificate], fileType);

    this.fileSaverService.save(blob, `${this.data.name + 'certificate'}.cer`);
  }

}
